// src/graphql/collections.ts
import { gql } from "@apollo/client";

export const COLLECTIONS_QUERY = gql`
  query {
    collections {
      id
      name
      slug
      images
      description
      createdAt
      updatedAt
    }
  }
`;

export const COLLECTION_QUERY = gql`
  query ($slug: String!) {
    collection(slug: $slug) {
      id
      name
      slug
      description
      images
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_COLLECTIONS_QUERY = gql`
  query AdminCollections {
    adminCollections {
      id
      name
      slug
      description
      images
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_UPSERT_COLLECTION = gql`
  mutation (
    $id: ID
    $name: String!
    $slug: String
    $description: String
    $images: [String!]
  ) {
    adminUpsertCollection(
      input: {
        id: $id
        name: $name
        slug: $slug
        description: $description
        images: $images
      }
    ) {
      collection {
        id
        name
        slug
        description
        images
        createdAt
        updatedAt
      }
      errors
    }
  }
`;

export const ADMIN_DELETE_COLLECTION = gql`
  mutation ($id: ID!) {
    adminDeleteCollection(input: { id: $id }) {
      ok
      errors
    }
  }
`;
